import { IPasswordPolicy } from './IUserProfile.types';
import _ from 'lodash';
import {
  PasswordErrorMessage,
  BackendErrorCode,
  FrontendResponseErrorCode,
  ErrorCode,
} from '../../components/UserProfile/PasswordError.types';

export const formatPhone = (phone: string): string => {
  return phone.slice(0, 3) + ' ' + phone.slice(3, 6) + ' ' + phone.slice(6, 9) + ' ' + phone.slice(9, 12);
};

export const formatDate = (date: string | null): string => {
  if (date) {
    return `Zaktualizowano: ${date.slice(8, 10)}/${date.slice(5, 7)}/${date.slice(0, 4)}, ${date.slice(11, 16)}`;
  } else return '';
};

export const getPasswordPolicyMessage = (passwordPolicy: IPasswordPolicy): string => {
  const requirements: string[] = [];
  let includeIncluded = false;
  if (passwordPolicy.passwordLength) {
    requirements.push(`składać się przynajmniej z ${passwordPolicy.passwordLength} znaków`);
  }
  if (passwordPolicy.requireLowercase || passwordPolicy.requireUppercase) {
    let caseRequirement = '';
    if (passwordPolicy.requireLowercase) {
      caseRequirement += 'małą';
    }
    if (passwordPolicy.requireLowercase && passwordPolicy.requireUppercase) {
      caseRequirement += ' i ';
    }
    if (passwordPolicy.requireUppercase) {
      caseRequirement += 'dużą';
    }
    includeIncluded = true;
    requirements.push(`zawierać ${caseRequirement} literę`);
  }
  if (passwordPolicy.requireDigit) {
    requirements.push(`${!includeIncluded ? 'zawierać ' : ''}cyfrę`);
    includeIncluded = true;
  }
  if (passwordPolicy.requireNonAlphanumeric) {
    requirements.push(
      `${!includeIncluded ? 'zawierać ' : ''
      }znak specjalny (np: ! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ ] ^ _\` { | } )`,
    );
    includeIncluded = true;
  }
  if (requirements.length > 2) {
    return `Hasło musi ${requirements.slice(0, requirements.length - 1).join(', ')} oraz ${requirements[requirements.length - 1]
      }`;
  } else {
    return `Hasło musi ${requirements.join(' oraz ')}`;
  }
};

export const validatePasswordWithPolicy = (password: string, passwordPolicy: IPasswordPolicy): boolean => {
  if (!password || !passwordPolicy.regex) {
    return false;
  }
  const regex = new RegExp(passwordPolicy.regex);

  if (!regex.test(password)) {
    return false;
  }

  return true;
};

export const getErrorMessages = (errorCode: ErrorCode) => {
  switch (errorCode) {
    case BackendErrorCode.PasswordTooShort:
      return PasswordErrorMessage.PasswordTooShort;
    case BackendErrorCode.PasswordRequiresNonAlphanumeric:
      return PasswordErrorMessage.PasswordRequiresNonAlphanumeric;
    case BackendErrorCode.PasswordRequiresDigit:
      return PasswordErrorMessage.PasswordRequiresDigit;
    case BackendErrorCode.PasswordRequiresUpper:
      return PasswordErrorMessage.PasswordRequiresUpper;
    case BackendErrorCode.PasswordRequiresLower:
      return PasswordErrorMessage.PasswordRequiresLower;
    case BackendErrorCode.PasswordTheSame:
      return PasswordErrorMessage.PasswordTheSame;
    case BackendErrorCode.PasswordMismatch:
      return PasswordErrorMessage.PasswordMismatch;
    case FrontendResponseErrorCode.PasswordsNotTheSame:
      return PasswordErrorMessage.PasswordsNotTheSame;
    case FrontendResponseErrorCode.PasswordIsInvalid:
      return PasswordErrorMessage.PasswordIsInvalid;
  }
};
